import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Pause token refresh while backgrounded; restart immediately on resume.
// Without this, Android/PWA freezes kill the refresh timer and the JWT
// expires silently, causing all authenticated requests to fail until
// a full page reload.
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    supabase.auth.stopAutoRefresh();
  } else {
    supabase.auth.startAutoRefresh();
  }
});

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string;
          email: string;
          full_name: string | null;
          role:
            | 'Admin'
            | 'Projectleider'
            | 'Werkvoorbereider'
            | 'Onderaannemer'
            | 'Administratie'
            | 'Planner'
            | 'Adviseur'
            | 'Secretaresse';
          created_at: string;
        };
        Insert: {
          id: string;
          email: string;
          full_name?: string | null;
          role:
            | 'Admin'
            | 'Projectleider'
            | 'Werkvoorbereider'
            | 'Onderaannemer'
            | 'Administratie'
            | 'Planner'
            | 'Adviseur'
            | 'Secretaresse';
          created_at?: string;
        };
        Update: {
          id?: string;
          email?: string;
          full_name?: string | null;
          role?:
            | 'Admin'
            | 'Projectleider'
            | 'Werkvoorbereider'
            | 'Onderaannemer'
            | 'Administratie'
            | 'Planner'
            | 'Adviseur'
            | 'Secretaresse';
          created_at?: string;
        };
      };
      projects: {
        Row: {
          id: string;
          project_number: string;
          name: string;
          client_name: string;
          address: string | null;
          start_date: string | null;
          end_date: string | null;
          contact_person_name: string | null;
          contact_person_email: string | null;
          contact_person_phone: string | null;
          description: string | null;
          status: 'Werkvoorbereiding' | 'Uitvoering' | 'Oplevering' | 'Afgerond' | 'Vervallen';
          created_by: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          project_number: string;
          name: string;
          client_name: string;
          address?: string | null;
          start_date?: string | null;
          end_date?: string | null;
          contact_person_name?: string | null;
          contact_person_email?: string | null;
          contact_person_phone?: string | null;
          description?: string | null;
          status?: 'Werkvoorbereiding' | 'Uitvoering' | 'Oplevering' | 'Afgerond' | 'Vervallen';
          created_by?: string | null;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          project_number?: string;
          name?: string;
          client_name?: string;
          address?: string | null;
          start_date?: string | null;
          end_date?: string | null;
          contact_person_name?: string | null;
          contact_person_email?: string | null;
          contact_person_phone?: string | null;
          description?: string | null;
          status?: 'Werkvoorbereiding' | 'Uitvoering' | 'Oplevering' | 'Afgerond' | 'Vervallen';
          created_by?: string | null;
          created_at?: string;
          updated_at?: string;
        };
      };
    };
  };
};
